import { render, staticRenderFns } from "./tabContent.vue?vue&type=template&id=640bfd7e&scoped=true"
import script from "./tabContent.vue?vue&type=script&lang=js"
export * from "./tabContent.vue?vue&type=script&lang=js"
import style0 from "./tabContent.vue?vue&type=style&index=0&id=640bfd7e&prod&lang=scss"
import style1 from "./tabContent.vue?vue&type=style&index=1&id=640bfd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bfd7e",
  null
  
)

export default component.exports